import {HOME} from '../../../config/constants/routes';

// 既存のエントリー訴求モーダルと件数を揃える
export const UNFINISHED_ENTRY_PROMPT_ITEM_LIMIT = 3;

type Args = {
  isAuthenticated: boolean;
  isAppWebView: boolean;
  pathname: string;
  isSuppressed: boolean;
};

/**
 * APIを呼んでよい状況かを判定する。
 * ホームに限るのは、閲覧中の募集やエントリー手続きを邪魔しないため。
 * アプリ内WebViewを除くのは、アプリ側のポップアップと二重に出さないため。
 */
export const canRequestUnfinishedEntryPrompt = ({
  isAuthenticated,
  isAppWebView,
  pathname,
  isSuppressed,
}: Args): boolean =>
  isAuthenticated && !isAppWebView && pathname === HOME && !isSuppressed;
